/* eslint-disable i18n/no-russian-character */
'use client';

import { usePathname } from 'next/navigation';
import Script from 'next/script';

interface ScriptChat2deskProps {
  token?: string;
}

export const ScriptChat2desk = ({ token }: ScriptChat2deskProps) => {
  const pathname = usePathname();

  const path = pathname ?? '';

  const excludedPaths = [
    '/checkout',
    '/checkout/success',
    '/survey/diagnostic',
    '/ie_intensive_hyaluronic',
    '/ie_ageproteom',
    '/ie_intensive_nad',
    '/eau-cellulaire',
    '/bioderma_atoderm',
    '/bioderma_hydrabio',
    '/bioderma_sebium',
    '/acneproject',
    '/sochetannye_metodiki',
    '/bioderma_galchonok'
  ];

  if (!token) {
    return null;
  }

  const isExcludedByPath = excludedPaths.some(
    (excludedPath) =>
      path === excludedPath || path.startsWith(excludedPath + '/')
  );

  const isExcludedByHost =
    typeof window !== 'undefined' &&
    window.location.hostname === 'acneproject.naos.ru';

  const isExcluded = isExcludedByPath || isExcludedByHost;

  const chat24Url = 'https://livechatv2.chat2desk.com';
  const chat24SocketUrl = 'wss://livechatv2.chat2desk.com/widget_ws_new';
  const chat24StaticFilesDomain = 'https://storage.chat2desk.com/';

  return (
    <>
      <Script
        id="chat2desk-init"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            window.chat24_token = ${JSON.stringify(token)};
            window.chat24_url = ${JSON.stringify(chat24Url)};
            window.chat24_socket_url = ${JSON.stringify(chat24SocketUrl)};
            window.chat24_static_files_domain = ${JSON.stringify(chat24StaticFilesDomain)};
            window.lang = 'ru';
            window.fetch(
                window.chat24_url + '/packs/manifest.json?nocache=' + new Date().getTime()
            )
                .then(function(res){ return res.json(); })
                .then(function(data){
                    var chat24 = document.createElement('script');
                    chat24.type = 'text/javascript';
                    chat24.async = true;
                    chat24.id = 'chat2desk-app';
                    chat24.src = window.chat24_url + data['application.js'];
                    document.body.appendChild(chat24);
                    
                    // MutationObserver для отслеживания появления chat-24
                    const observer = new MutationObserver(function(mutations) {
                        mutations.forEach(function(mutation) {
                            mutation.addedNodes.forEach(function(node) {
                                if (node.nodeType === 1 && node.tagName === 'CHAT-24') {                                    
                                    function injectStyles(attempts = 0) {
                                        if (attempts > 5) {
                                            observer.disconnect();
                                            return;
                                        }
                                        
                                        if (node.shadowRoot) {
                                            const styleElement = document.createElement('style');
                                            styleElement.textContent = \`
                                                .startBtn {
                                                    bottom: calc(var(--tap-mobile-height) + 12px) !important;
                                                }
                                            \`;
                                            
                                            // Вставляем в Shadow DOM
                                            node.shadowRoot.appendChild(styleElement);
                                            observer.disconnect();
                                            return;
                                        }
                                        
                                        setTimeout(() => injectStyles(attempts + 1), 500);
                                    }
                                    
                                    setTimeout(injectStyles, 1000);
                                }
                            });
                        });
                    });
                    
                    // Начинаем наблюдение за изменениями в DOM
                    observer.observe(document.body, {
                        childList: true,
                        subtree: true
                    });
                });
            `
        }}
      />
      {isExcluded ? (
        <style>{`
          #chat24_widget,
          .chat24-widget,
          #chat24-button,
          .chat24-button,
          #chat24_container,
          [id^='chat24'] {
            display: none !important;
            visibility: hidden !important;
            opacity: 0 !important;
            pointer-events: none !important;
          }
        `}</style>
      ) : null}
    </>
  );
};
